<af-main-container [title]="'i18n_af_knowledgeBaseArchive' | translate"
                   [showBreadcrumbs]="true"
                   [tabPathToTab]="tabPathToTab"
                   [enableScroll]="false">
    <af-knowledge-base-documents-tab fxFlex class="w-100 h-100" mode="archive"/>
</af-main-container>
